unit UStampModel;

interface

uses
  UEssentialHelper, Js, UResultModel, UFakModel, UTaetModel, UKstModel,
  UMatModel, WebLib.Controls, WebLib.Storage;

type
  TStampModel = class
  private
    FPersonalNr: string;
    FZeitpunkt: TDateTime;
    FArt: string;
    FOnPropertyChanged: TCallback;
    FStatus: string;
    FResult: TResultModel;
    FFak: TFakModel;
    FTaet: TTaetModel;
    FKst: TKstModel;
    FMat: TMatModel;
    FMenge: Double;
    FOnError: TErrorEvent;
    FHasComments: Boolean;
    FHasPictures: Boolean;
    FLon: string;
    FLat: string;
    FHasPdfs: Boolean;
    FOnValueChanged: TPropertyChangedEvent;
    procedure CalcStatus;
    procedure ClearValues;
    procedure DoError(AMsg: string);
    procedure DoValueChanged(PropertyName: string);
    procedure PropertyChanged;
    procedure SetValues(Obj: TJsObject); overload;
    procedure SetValues(Json: string); overload;
    procedure SetArt(const Value: string);
    procedure SetPersonalNr(const Value: string);
    procedure SetZeitpunkt(const Value: TDateTime);
    procedure SetOnPropertyChanged(const Value: TCallback);
    procedure SetResult(const Value: TResultModel);
    procedure SetFak(const Value: TFakModel);
    procedure SetTaet(const Value: TTaetModel);
    procedure SetKst(const Value: TKstModel);
    procedure SetMat(const Value: TMatModel);
    procedure SetMenge(const Value: Double);
    procedure SetOnError(const Value: TErrorEvent);
    procedure SetHasComments(const Value: Boolean);
    procedure SetHasPictures(const Value: Boolean);
    procedure SetLat(const Value: string);
    procedure SetLon(const Value: string);
    procedure SetHasPdfs(const Value: Boolean);
    procedure SetOnValueChanged(const Value: TPropertyChangedEvent);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    constructor Create(Obj: TJsObject); overload;
    function Equals(Other: TStampModel): Boolean;
    function ToJson: string;
    function ToString: string; override;
    procedure GetLastDefStamp(Url: string; Nr: string);
    procedure GetLastFak(Url: string);
    procedure GetLastFakStamp(Url: string);
    procedure GetLastStamp(Url: string);
    procedure Insert(Url: string);
    property PersonalNr: string read FPersonalNr write SetPersonalNr;
    property Art: string read FArt write SetArt;
    property Zeitpunkt: TDateTime read FZeitpunkt write SetZeitpunkt;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
    property OnError: TErrorEvent read FOnError write SetOnError;
    property Status: string read FStatus;
    property Result: TResultModel read FResult write SetResult;
    property Fak: TFakModel read FFak write SetFak;
    property Taet: TTaetModel read FTaet write SetTaet;
    property Kst: TKstModel read FKst write SetKst;
    property Mat: TMatModel read FMat write SetMat;
    property Menge: Double read FMenge write SetMenge;
    property HasComments: Boolean read FHasComments write SetHasComments;
    property HasPictures: Boolean read FHasPictures write SetHasPictures;
    property Lat: string read FLat write SetLat;
    property Lon: string read FLon write SetLon;
    property HasPdfs: Boolean read FHasPdfs write SetHasPdfs;
    property OnValueChanged: TPropertyChangedEvent read FOnValueChanged write SetOnValueChanged;
  end;

implementation

uses
  WebLib.REST, System.SysUtils, WebLib.Json;

{ TStampModel }

procedure TStampModel.CalcStatus;
begin
  Self.FStatus := ArtToStatus(Self.Art) + ' seit ' +
    FormatDateTime('ddd. dd.mm.yyyy hh:nn', Self.Zeitpunkt);
end;

procedure TStampModel.ClearValues;
begin
  Self.PersonalNr := '';
  Self.Art := '';
  Self.Zeitpunkt := 0;
  Self.FStatus := '';
  Self.Result := TResultModel.Create;
  if Self.Fak = nil then
    Self.Fak := TFakModel.Create
  else
    Self.Fak.ClearValues;
  if Self.Taet = nil then
    Self.Taet := TTaetModel.Create
  else
    Self.Taet.ClearValues;
  if Self.Kst = nil then
    Self.Kst := TKstModel.Create
  else
    Self.Kst.ClearValues;
  if Self.Mat = nil then
    Self.Mat := TMatModel.Create
  else
    Self.Mat.ClearValues;
  Self.Menge := 0;
  Self.HasComments := false;
  Self.HasPictures := false;
  Self.Lat := '';
  Self.Lon := '';
  Self.HasPdfs := false;
end;

constructor TStampModel.Create(Obj: TJsObject);
begin
  Self.SetValues(Obj);
end;

procedure TStampModel.DoError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TStampModel.DoValueChanged(PropertyName: string);
begin
  if Assigned(Self.OnValueChanged) then
    Self.OnValueChanged(Self, PropertyName);
end;

function TStampModel.Equals(Other: TStampModel): Boolean;
begin
  if Other = nil then
    Result := false
  else
  begin
    Result := Self.PersonalNr = Other.PersonalNr;
    Result := Result and (Self.Art = Other.Art);
    Result := Result and DateTimesAreEqual(Self.Zeitpunkt, Other.Zeitpunkt);
  end;
end;

constructor TStampModel.Create(Json: string);
begin
  Self.ClearValues;
  Self.SetValues(Json);
end;

procedure TStampModel.GetLastDefStamp(Url, Nr: string);
var
  Obj: TJsonObject;
  helper, cmd: string;
  client: TRestClient;
  procedure Response(sender: TObject; aResponse: string);
  var
    jso: TJsObject;
  begin
    if aResponse <> '' then
      TLocalStorage.SetValue(cmd, aResponse)
    else
      aResponse := TLocalStorage.GetValue(cmd);
    if aResponse <> '' then
    begin
      jso := TJsJson.parseObject(aResponse);
      if jso['value'] <> nil then
        Self.SetValues(string(jso['value']));
      Self.PropertyChanged;
    end
    else
      Self.DoError('Verbindungsfehler: TStampModel.GetLastDefStamp');
  end;

  procedure ErrorHandler(sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(sender, '');
  end;

begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', Self.PersonalNr);
  Obj.AddPair('Nr', Nr);
  helper := Obj.ToString;
  cmd := Url + '/StampService/GetLastDefStamp_' + helper;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  client.HttpsPost(Url + '/StampService/GetLastDefStamp', 'application/json',
    Obj.ToString);
end;

procedure TStampModel.GetLastFak(Url: string);
var
  client: TRestClient;
  Obj: TJsonObject;
  s, cmd: string;
  procedure Response(sender: TObject; aResponse: string);
  var
    jso: TJsObject;
  begin
    if aResponse <> '' then
      TLocalStorage.SetValue(cmd, aResponse)
    else
      aResponse := TLocalStorage.GetValue(cmd);
    if aResponse <> '' then
    begin
      jso := TJsJson.parseObject(aResponse);
      if jso['value'] <> nil then
        Self.SetValues(string(jso['value']));
      Self.PropertyChanged;
    end
    else
      Self.DoError('Verbindungsfehler: TStampModel.GetLastFak');
  end;

  procedure ErrorHandler(sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(Self, '');
  end;

begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', Self.PersonalNr);
  s := Obj.ToString;
  cmd := Url + '/StampService/GetLastFak_' + s;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', s);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  client.HttpsPost(Url + '/StampService/GetLastFak', 'application/json',
    Obj.ToString);
end;

procedure TStampModel.GetLastFakStamp(Url: string);
var
  client: TRestClient;
  Obj: TJsonObject;
  cmd, s: string;
  procedure Response(sender: TObject; aResponse: string);
  var
    jso: TJsObject;
  begin
    if aResponse <> '' then
      TLocalStorage.SetValue(cmd, aResponse)
    else
      aResponse := TLocalStorage.GetValue(cmd);
    if aResponse <> '' then
    begin
      jso := TJsJson.parseObject(aResponse);
      if jso['value'] <> nil then
        Self.SetValues(string(jso['value']));
      Self.PropertyChanged;
    end
    else
      Self.DoError('Verbindungsfehler: TStampModel.GetLastFakStamp');
  end;

  procedure ErrorHandler(sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(Self, '');
  end;

begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', Self.PersonalNr);
  s := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', s);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  cmd := Url + '/StampService/GetLastFakStamp_' + Obj.ToString;
  client.HttpsPost(Url + '/StampService/GetLastFakStamp', 'application/json',
    Obj.ToString);
end;

procedure TStampModel.GetLastStamp(Url: string);
var
  client: TRestClient;
  Obj: TJsonObject;
  cmd, s: string;
  procedure Response(sender: TObject; aResponse: string);
  var
    jso: TJsObject;
  begin
    if aResponse <> '' then
      TLocalStorage.SetValue(cmd, aResponse)
    else
      aResponse := TLocalStorage.GetValue(cmd);
    if aResponse <> '' then
    begin
      jso := TJsJson.parseObject(aResponse);
      if jso['value'] <> nil then
        Self.SetValues(string(jso['value']));
      Self.PropertyChanged;
    end
    else
      Self.DoError('Verbindungsfehler: TStampModel.GetLasStamp');
  end;

  procedure ErrorHandler(sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(Self, '');
  end;

begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', Self.PersonalNr);
  s := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', s);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  cmd := Url + '/StampService/GetLastStamp_' + Obj.ToString;
  client.HttpsPost(Url + '/StampService/GetLastStamp', 'application/json',
    Obj.ToString);
end;

procedure TStampModel.Insert(Url: string);
var
  Obj: TJsonObject;
  client: TRestClient;
  procedure Response(sender: TObject; aResponse: string);
  begin
    Self.Result := TResultModel.Create(aResponse);
    Self.PropertyChanged;
  end;

  procedure ErrorHandler(sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Self.DoError('TStampModel.Insert fehlgeschlagen');
  end;

begin
  Obj := TJsonObject.Create;
  Obj.AddPair('value', Self.ToJson);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  client.HttpsPost(Url + '/StampService/Insert', 'application/json',
    Obj.ToString);
  Obj.Free;
end;

procedure TStampModel.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

constructor TStampModel.Create;
begin
  Self.ClearValues;
end;

procedure TStampModel.SetArt(const Value: string);
begin
  FArt := Value;
  Self.CalcStatus;
end;

procedure TStampModel.SetFak(const Value: TFakModel);
begin
  FFak := Value;
end;

procedure TStampModel.SetHasComments(const Value: Boolean);
begin
  FHasComments := Value;
end;

procedure TStampModel.SetHasPdfs(const Value: Boolean);
begin
  if FHasPdfs <> Value then
  begin
    FHasPdfs := Value;
    Self.DoValueChanged('HasPdfs');
  end;
end;

procedure TStampModel.SetHasPictures(const Value: Boolean);
begin
  FHasPictures := Value;
end;

procedure TStampModel.SetKst(const Value: TKstModel);
begin
  FKst := Value;
end;

procedure TStampModel.SetLat(const Value: string);
begin
  FLat := Value;
end;

procedure TStampModel.SetLon(const Value: string);
begin
  FLon := Value;
end;

procedure TStampModel.SetMat(const Value: TMatModel);
begin
  FMat := Value;
end;

procedure TStampModel.SetMenge(const Value: Double);
begin
  FMenge := Value;
end;

procedure TStampModel.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TStampModel.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TStampModel.SetOnValueChanged(const Value: TPropertyChangedEvent);
begin
  FOnValueChanged := Value;
end;

procedure TStampModel.SetPersonalNr(const Value: string);
begin
  FPersonalNr := Value;
end;

procedure TStampModel.SetResult(const Value: TResultModel);
begin
  FResult := Value;
end;

procedure TStampModel.SetTaet(const Value: TTaetModel);
begin
  FTaet := Value;
end;

procedure TStampModel.SetValues(Json: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(Json);
  Self.SetValues(Obj);
end;

procedure TStampModel.SetValues(Obj: TJsObject);
begin
  Self.ClearValues;
  if Obj['PersonalNr'] <> nil then
    Self.PersonalNr := string(Obj['PersonalNr']);
  if Obj['Art'] <> nil then
    Self.Art := string(Obj['Art']);
  if Obj['Zeitpunkt'] then
    Self.Zeitpunkt := StrToDateTime(string(Obj['Zeitpunkt']));
  if Obj['Fak'] <> nil then
    Self.Fak.SetValues(string(Obj['Fak']));
  if Obj['Taet'] <> nil then
    Self.Taet.SetValues(string(Obj['Taet']));
  if Obj['Kst'] <> nil then
    Self.Kst.SetValues(string(Obj['Kst']));
  if Obj['Mat'] <> nil then
    Self.Mat.SetValues(string(Obj['Mat']));
  if Obj['Menge'] <> nil then
    Self.Menge := StrToFloat(string(Obj['Menge']));
  if Obj['HasComments'] <> nil then
    Self.HasComments := StrToBoolean(string(Obj['HasComments']));
  if Obj['HasPictures'] <> nil then
    Self.HasPictures := StrToBoolean(string(Obj['HasPictures']));
  if Obj['Lat'] <> nil then
    Self.Lat := string(Obj['Lat']);
  if Obj['Lon'] <> nil then
    Self.Lon := string(Obj['Lon']);
  if Obj['HasPdfs'] then
    Self.HasPdfs := StrToBoolean(string(Obj['HasPdfs']));
end;

procedure TStampModel.SetZeitpunkt(const Value: TDateTime);
begin
  FZeitpunkt := Value;
  Self.CalcStatus;
end;

function TStampModel.ToJson: string;
var
  Obj: TJsonObject;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', Self.PersonalNr);
  Obj.AddPair('Art', Self.Art);
  Obj.AddPair('Zeitpunkt', DateTimeToStr(Self.Zeitpunkt));
  Obj.AddPair('Fak', Self.Fak.ToJson);
  Obj.AddPair('Taet', Self.Taet.ToJson);
  Obj.AddPair('Kst', Self.Kst.ToJson);
  Obj.AddPair('Mat', Self.Mat.ToJson);
  Obj.AddPair('Menge', FloatToStr(Self.Menge));
  Obj.AddPair('HasComments', BooleanToStr(Self.HasComments));
  Obj.AddPair('HasPictures', BooleanToStr(Self.HasPictures));
  Obj.AddPair('Lat', Self.Lat);
  Obj.AddPair('Lon', Self.Lon);
  Obj.AddPair('HasPdfs', BooleanToStr(Self.HasPdfs));
  Result := Obj.ToString;
  Obj.Free;
end;

function TStampModel.ToString: string;
begin
  Result := FormatDateTime('dd.mm.yy hh:nn', Self.Zeitpunkt) + ' ' + Self.Art;
  if (Self.Fak <> nil) and (Self.Fak.Id > 0) then
    Result := Result + ' ' + Self.Fak.ToStringV1;
end;

end.
